const logoutUser = () => {
    //logout the user
    window.hubCookie.unset();

    //redirect to the home page
    window.location = window.hubConfig.defaultUrl;
};

export { logoutUser };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Login/logout.js